import { billingRequest } from "./billing-client";

export interface InvoiceTemplateDto {
  id: string;
  code: string;
  name: string;
  category: string;
  previewUrl: string | null;
  config: unknown;
}

export const invoiceTemplatesApi = {
  list: () => billingRequest<{ items: InvoiceTemplateDto[] }>("/invoice-templates"),
};
